import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";


const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "tournament/master-action", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "tournament/list", {}, headerConfig);
        return response;
};


const tournamentService = {
    save,
    list    
};

export default tournamentService;